import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=58815ec1&scoped=true&"
import script from "./Standard.vue?vue&type=script&lang=ts&"
export * from "./Standard.vue?vue&type=script&lang=ts&"
import style0 from "./Standard.vue?vue&type=style&index=0&id=58815ec1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58815ec1",
  null
  
)

export default component.exports